import { useEffect, useState } from 'react';
import { Table, TableProps } from 'antd';

interface SearchAuthorizationTableProps extends TableProps<any> {
  onTableChangeHandler: any,
  columns: Array<Object>,
  dataSource: Array<Object>,
  totalResultCount: number,
}

const SearchAuthorizationTable = (props: SearchAuthorizationTableProps) => {

  const DEFAULT_PAGE_NUM = 1;
  const DEFAULT_PAGE_SIZE = 20;
  const [page, setPage] = useState(DEFAULT_PAGE_NUM);

  useEffect(() => {
    setPage(DEFAULT_PAGE_NUM);
  }, [props.dataSource])

  return (
    <Table
      {...props}
      columns={props.columns}
      dataSource={props.dataSource}
      pagination={{ 
        current: page,
        position: ['bottomCenter'], 
        showSizeChanger: true, 
        defaultPageSize: DEFAULT_PAGE_SIZE, 
        total: props.totalResultCount,
        onChange: (num: number) => {
          setPage(num);
        }
      }}
    />
  );
}

export default SearchAuthorizationTable;